import { GetLocalState } from "Connectivity/LocalStorage";
import Cookies from "js-cookie";
import { PLATFORM } from "Helpers/platform";

export const AssetReplacer = (path:string, addClientToPath = false) => {

  if ( !path || path === undefined ) return "";

  const CLIENT  = GetLocalState("settings").Client;
  const CDN     = GetLocalState("settings").paths.CDN;
  const THEME   = Cookies.get("bo-theme");
  
  if ( !path ) return "";
  
  if ( path.includes("[[CDN_ROOT]]") ) {
    const replaceText = addClientToPath ? CDN + "/" + CLIENT : CDN;
    path = path.replace('[[CDN_ROOT]]', replaceText);
  }
  
  if ( path.includes("[[PLATFORM_FOLDER]]") ) {
    path = path.replace('[[PLATFORM_FOLDER]]', PLATFORM);
  }
  
  if ( THEME !== "" && typeof THEME === "string" ) {
    path = path.replace('[[THEME]]', THEME);
  }

  return path;

}